export default __webpack_public_path__ + "static/media/arrow_news_announcement.9d9199d6.svg";